// Shared builder for the inbound-advice approve/reject notification emails.
// The two exports differ only in heading, one body sentence, and the CTA link
// suffix (/show vs /edit), so they delegate to a single skeleton.
const buildInboundAdviceEmail = (
  fromName,
  fromEmail,
  reloadYard,
  inbound,
  { heading, body, linkSuffix },
) => {
  let poNumber = "";
  let railCarNumber = "";

  if (inbound.poNumber && inbound.poNumber.trim()) {
    poNumber += `<strong>PO Number:</strong> ${inbound.poNumber}<br>`;
  }

  if (inbound.railCarNumber) {
    railCarNumber += `<strong>Car/Trailer Number:</strong> ${inbound.railCarNumber}<br>`;
  }

  return `<!-- Begin HTML Content -->
        <h2> ${heading} <br></h2>
        <hr style="background:#2d8cff; height: 8px; width: 60px; border-style: solid; border-color: #095484; border-width: 1px 0 0 0; border-radius: 8px;" />
        <br><br>
        Here are the details:
        <br><br>
        ${poNumber}
        ${railCarNumber}
        <strong>Facility:</strong> ${reloadYard.name}<br>
        <strong>Address:</strong> ${reloadYard.street}<br>
        ${reloadYard.city}, ${reloadYard.state} ${reloadYard.zipCode}
        <br><br>
        ${body}
        <br><br><br>
        <table bgcolor="#FF5F0F" style="border-radius:3px; border-spacing:0; margin:0 auto">
            <tbody>
                <tr style="background:#FF5F0F;">
                    <td class="mobile-cta" style="border: 0 solid #FF5F0F;  display: inline-block; padding: 20px 45px; text-align: center; font-family:'Lato', Helvetica, sans-serif; font-size:15px; line-height:24px; color:#FFFFFF; font-weight:900; text-decoration: none; text-transform: uppercase; letter-spacing: .2em">
                        <a href="https://app.transloads.co/inboundShipments/${inbound.id}/${linkSuffix}"
                            target="_blank"
                            rel="noreferrer"
                            style="color:#FFFFFF; text-decoration:none;"
                        >
                            VIEW INBOUND
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
        <br><br>
        <hr style="border-bottom:#CCCCCC 6px dotted; border-width: 0 0 6px 0;">
        <br>
        If you have any questions, please contact ${fromName} at ${fromEmail}.
        <!-- End HTML Content -->`;
};

export function emailInboundAdviceApprovedHTML(
  fromName,
  fromEmail,
  reloadYard,
  inbound,
) {
  return buildInboundAdviceEmail(fromName, fromEmail, reloadYard, inbound, {
    heading: "Your Inbound Shipment advice was approved!",
    body: "Your shipment is now being tracked toward arrival. No further action is required.",
    linkSuffix: "show",
  });
}

export function emailInboundAdviceRejectedHTML(
  fromName,
  fromEmail,
  reloadYard,
  inbound,
) {
  return buildInboundAdviceEmail(fromName, fromEmail, reloadYard, inbound, {
    heading: "Your Inbound Shipment advice was rejected.",
    body: "Please review your inbound advice and inspect the NOTES tab for additional information, then correct and resubmit.",
    linkSuffix: "edit",
  });
}
